import { addMonths } from 'date-fns';

const monthMap = {
  0: 'styczniu',
  1: 'lutym',
  2: 'marcu',
  3: 'kwietniu',
  4: 'maju',
  5: 'czerwcu',
  6: 'lipcu',
  7: 'sierpniu',
  8: 'wrześniu',
  9: 'październiku',
  10: 'listopadzie',
  11: 'grudniu',
};

const prevMonthName = monthMap[addMonths(new Date(), -1).getMonth()];

export default prevMonthName;
